import { configureStore } from '@reduxjs/toolkit';

import { mainApi } from 'slices/index';

const prodMiddlewares = [];

const store = configureStore({
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(mainApi.middleware).concat(prodMiddlewares),
  reducer: {
    [mainApi.reducerPath]: mainApi.reducer,
    // other reducers ...
  },
  preloadedState: {},
});

export { store };
